import { createObjectIntentType, getIntents } from '../intent';
export const omitProps = createObjectIntentType('omitProps', (decorate)=>(obj)=>decorate(obj));
export function applyOmitProps(revision) {
    const propsToOmit = getIntents(omitProps, revision);
    if (!propsToOmit) {
        return;
    }
    const propNames = Object.keys(propsToOmit);
    for(let i = 0; i < propNames.length; i++){
        const propName = propNames[i];
        delete revision.props[propName];
    }
}

//# sourceMappingURL=omitProps.js.map